var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9385 11.6849C13.9385 11.9144 13.7524 12.1005 13.5229 12.1005C13.2935 12.1005 13.1074 11.9144 13.1074 11.6849C13.1074 11.6873 13.1074 11.6886 13.1075 11.6886C13.1085 11.6887 13.1219 11.5751 13.2934 11.3179C13.3554 11.2249 13.4315 11.1229 13.5229 11.0118C13.6144 11.1229 13.6905 11.2249 13.7525 11.3179C13.924 11.5751 13.9374 11.6887 13.9384 11.6886C13.9385 11.6886 13.9385 11.6873 13.9385 11.6849Z",
    fill: "#344054",
    stroke: "#344054",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80908 1.95471L9.06023 3.20587",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80977 2.95569L3.30469 8.4608L7.3084 12.4645L12.8135 6.95939L8.80977 2.95569Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67578 7.11035L10.678 9.08373",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84473 15.2238H16",
    stroke: "#344054",
    strokeWidth: 1.41553,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditColor);
export default __webpack_public_path__ + "static/media/edit-color.233d1b5b88bbe59c42b029f729e6ce67.svg";
export { ForwardRef as ReactComponent };